
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-row>
            <el-col :span="16">
              <el-row>
                <el-form-item label="采购编号">
                  <el-input
                    v-model="searchForm.stockInCode"
                    placeholder="采购编号"
                    size="small"
                    clearable
                  />
                </el-form-item>
                <el-form-item label="试剂耗材">
                  <el-input
                    v-model="searchForm.shijihaocaiMingcheng"
                    placeholder="名称/品牌/货号/CAS号"
                    size="small"
                    clearable
                  />
                </el-form-item>

                <el-form-item :label="'类'+getSpac+getSpac+'型'">
                  <el-select v-model="searchForm.statusDictKey" placeholder="入出库类型" size="small" clearable="">
                    <el-option
                      v-for="item in getComboxData('F03')"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="'操作者'">
                  <el-select v-model="searchForm.operUserId" placeholder="操作者" size="small" clearable="">
                    <el-option
                      v-for="item in ketiMemberList"
                      :key="item.userKey"
                      :label="item.userName"
                      :value="item.userKey"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>

                <el-form-item label="课题名称">
                  <el-input v-model="searchForm.ketiMingcheng" placeholder="课题名称" size="small" clearable />
                </el-form-item>
                <el-form-item label="实验名称">
                  <el-input v-model="searchForm.shiyanMingcheng" placeholder="实验名称" size="small" clearable />
                </el-form-item>
                <el-form-item :label="'用'+getSpac+'途'">
                  <el-input v-model="searchForm.yongtu" placeholder="用途" size="small" clearable />
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="8">
              <div class="btn-box" style="float: right;">
                <el-row>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="handleSearch">
                      查询
                      <i class="el-icon-search el-icon--right" />
                    </el-button>
                  </el-form-item>

                  <el-form-item>
                    <el-button size="small" type="primary" @click="handleExport">
                      导出
                      <i class="el-icon-download el-icon--right" />
                    </el-button>
                  </el-form-item>

                  <el-form-item>
                    <el-button size="small" type="primary" @click="handleBack">
                      返回
                      <i class="el-icon-back el-icon--right" />
                    </el-button>
                  </el-form-item>
                </el-row>

              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleResort"
    >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" />

      <el-table-column prop="stockInCode" label="采购编号" width="120px" sortable="custom" />
      <el-table-column prop="operUserId" label="操作者" width="100px" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.operUserName }}
        </template>
      </el-table-column>
      <el-table-column prop="operRiqi" label="操作日期" width="120px" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.operRiqi | dateFmt('{m}-{d} {h}:{i}') }}
        </template>
      </el-table-column>
      <el-table-column prop="typeDictKey" label="入出库类型" width="120px" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.typeDictName }}
        </template>
      </el-table-column>

      <el-table-column prop="shijihaocaiMingcheng" label="试剂耗材名称" width="180px">
        <template slot-scope="scope">
          {{ scope.row.stockInfo.shijihaocaiMingcheng }}
        </template>
      </el-table-column>

      <el-table-column prop="inOutQty" label="入出库数量" width="120px" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.inOutQty | decFmt(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="jieyu" label="结余" width="120px" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.jieyu | decFmt(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="ketiBianhao" label="课题编号" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="ketiMingcheng" label="课题名称" width="150px" :show-overflow-tooltip="true" />
      <el-table-column prop="shiyanMingcheng" label="实验名称" width="150px" :show-overflow-tooltip="true" />
      <el-table-column prop="yongtu" label="用途" min-width="100px" :show-overflow-tooltip="true" />

      <el-table-column
        fixed="right"
        label="操作"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.typeDictKey==='F0302'"
            type="text"
            size="mini"
            @click.stop="handleDoBack(scope.row)"
          >退库</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
    <Tuiku ref="tuiku" :back-id="backId" />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
// import ShowUpload from './ShowUpload'
import KxjCom from '@/utils/kxjcom'
import Tuiku from '@/views/managesystem/zy/zy02/edit-tuiku.vue'
export default {
  components: {
    // Assist,
    Tuiku
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateTimeFormat(val).substr(5, 11)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  data() {
    return {
      moduleCode: 'zy03',
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        keyWord: ''
      },
      ketiMemberList: [], // 课题组成员
      entityId: null,
      backId: null
    }
  },
  computed: {
    getSpac() {
      return '　'
    }
  },

  // 初期化数据
  created() {
    // 绑定检索
    this.$bus.$off('handleReload')
    this.$bus.$on('handleReload', this.handleSearch)

    this.handleSearch()
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('F01;F02').then(res => {
      this.allComboxData = res.data.result
    })

    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm('api/services/app/Com/GetKetizuMember').then(resp => {
      this.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  activated() {
    this.handleSearch()
  },
  mounted() {
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      that.searchForm.zy02id = this.$route.params.zy02id
      var path = '/api/services/app/zy02/GetPagedListzy0201s'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },

    /** 做退库 */
    handleDoBack(row) {
      this.backId = row.id
      this.$refs.tuiku.show()
    },

    handleBack() {
      this.$router.push('/zy/zy0203')
    },

    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '采购编号',
          '操作者',
          '操作日期',
          '入出库类型',
          '试剂耗材名称',
          '入出库数量',
          '结余',
          '课题编号',
          '课题名称',
          '实验名称',
          '用途'
        ]
        const filterVal = [
          'stockInCode',
          'operUserName',
          'operRiqi',
          'typeDictName',
          'shijihaocaiMingcheng',
          'inOutQty',
          'jieyu',
          'ketiBianhao',
          'ketiMingcheng',
          'shiyanMingcheng',
          'yongtu'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '入出库详细', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    }

  }
}
</script>

<style scoped>
/* ffc059 */
</style>
